import React from 'react';
import { Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import { trackBookTrialLesson } from '@/lib/analytics';

const FinalCTASection = ({ scrollToBooking }) => {
  return (
    <section className="section-cream">
      <div className="section-container text-center">
        <div className="max-w-3xl mx-auto">
          <div className="accent-bar"></div>
          <h2 className="heading-lg mb-8">Ready to Achieve Your Goals?</h2>
          <p className="body-lg mb-10" style={{ color: 'var(--text-grey)' }}>
            Book your free trial session today and experience the difference personalized tutoring can make.
          </p>
          <Button onClick={() => { trackBookTrialLesson('final_cta'); scrollToBooking(); }} className="btn-gold text-lg px-14 py-6">
            <Calendar className="w-6 h-6" />
            Book Free Trial Session
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
